import { ReactNode } from 'react'
import { useTopBarPortalContext } from './TopBarPortalProvider'
import { Box, Divider } from '@mui/material'
import { createPortal } from 'react-dom'

type TopBarNavigationProps = {
  children: ReactNode
  isPrimary?: boolean
}

export default function TopBarNavigation({
  children,
  isPrimary = true,
}: TopBarNavigationProps) {
  const { portalNode, secondPortalNode } = useTopBarPortalContext()
  const node = isPrimary ? portalNode : secondPortalNode
  return node
    ? createPortal(
        <>
          {!isPrimary && portalNode ? <Divider /> : null}
          <Box>{children}</Box>
        </>,
        node,
      )
    : null
}
